module.exports = __webpack_public_path__ + "static/media/Hajj_insurance.69ab6642.svg";